__turbopack_context__.v({
  "displayDesktopIconLeading": "NavBarItem-module__CaIIZq__displayDesktopIconLeading",
  "iconLeading": "NavBarItem-module__CaIIZq__iconLeading",
  "iconTrailing": "NavBarItem-module__CaIIZq__iconTrailing",
  "isMenuOpen": "NavBarItem-module__CaIIZq__isMenuOpen",
  "navBarItem": "NavBarItem-module__CaIIZq__navBarItem",
  "text": "NavBarItem-module__CaIIZq__text",
});
